import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

import { ProxyService, UiModule } from '@seahorse/domain';
import { AddCustomUIModalComponent } from '../add-custom-ui-modal/add-custom-ui-modal.component';
import { navigation } from './sidebar.config';
import { LayoutService, SeahorseMenuItem } from '@seahorse/layout';
import { FormattingService } from '@seahorse/common';
import { CommonModule } from '@angular/common';
import { HasFeatureDirective } from '@seahorse/ui';
import { TranslateModule } from '@ngx-translate/core';
import { IdentityServiceBase } from '@seahorse/auth';

@Component({
  selector: 'ca-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [CommonModule, HasFeatureDirective, RouterModule, TranslateModule],
})
export class SidebarComponent implements OnInit, OnDestroy {
  navigationPrimary = [] as SeahorseMenuItem[];
  navigationSecondary = [] as SeahorseMenuItem[];
  uiModules = [] as UiModule[];
  sidebarOpen: boolean;
  subscriptions$ = new Subscription();

  private _layoutDisplayService = inject(LayoutService);
  private _layoutService = inject(LayoutService);

  constructor(
    private _formatting: FormattingService,
    private _identityService: IdentityServiceBase,
    private _ngbModal: NgbModal,
    private _proxyService: ProxyService,
    private _router: Router
  ) {}

  ngOnInit() {
    this.loadNavigation();
    this.subscriptions$.add(
      this._layoutDisplayService.navigationReload$.subscribe(() => {
        this.loadNavigation();
      })
    );

    this.subscriptions$.add(
      this._layoutService.sidebarToggle$.subscribe({
        next: (sidebarOpen) => {
          this.sidebarOpen = sidebarOpen;
        },
      })
    );
  }

  navigate(str: string) {
    const findPath = location.pathname.indexOf(str);
    if (findPath !== -1) {
      this._router
        .navigateByUrl('/not-found', { skipLocationChange: true })
        .then(() => this._router.navigate([str]));
    }
  }

  navigateToModule(module: UiModule) {
    this._router.navigate(['module', module.systemCode, module.entryRoute]);
  }

  loadNavigation() {
    this.uiModules = this._formatting.sortBy(
      this._proxyService.uiModules,
      'menuOrder'
    );
    this.navigationPrimary = navigation.filter(
      (x) =>
        (x.isSecondary === undefined || x.isSecondary === false) &&
        (!x.permissions || this._identityService.hasPermission(x.permissions))
    );

    this.navigationPrimary.sort((item1, item2) => {
      if (item1.order > item2.order) {
        return 1;
      } else if (item1.order < item2.order) {
        return -1;
      } else {
        return 0;
      }
    });
    this.navigationSecondary = navigation.filter(
      (x) =>
        x.isSecondary !== undefined &&
        x.isSecondary === true &&
        (!x.permissions || this._identityService.hasPermission(x.permissions))
    );

    this.navigationSecondary.sort((item1, item2) => {
      if (item1.order > item2.order) {
        return 1;
      } else if (item1.order < item2.order) {
        return -1;
      } else {
        return 0;
      }
    });
  }

  openNewCustomUiModal() {
    this._ngbModal.open(AddCustomUIModalComponent, {
      backdrop: 'static',
    });
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }

  toggleSidebar() {
    this._layoutDisplayService.toggleSidebarOpen();
  }
}
